import { Card, CardContent, CardHeader, Grid } from "@mui/material"
import { formatNumber, numberPrecision } from "../../../../helpers/UtilityHelper"
import InfoBox from "../../../../common/InfoBox"
import { StackedBarChart } from "../../../charts/BarChart"
import { STATUS_COLORS } from "../../../charts/colors"

const chartOptions = {
    layout: 'horizontal',
    xaxis: 'name',
    labelY: 'NDR Count',
    stackId: 'status',
    showLabels: true,
    legendAlign: 'left',
    totalAccessor: (entry) => { if (!entry) return null; const keys = ['totalDelivered', 'totalRTO', 'totalLost', 'totalOpen']; const t = keys.reduce((s,k)=>s+(entry[k]||0),0); return t||null; },
    data: [
        {dataKey: 'totalDelivered', label: 'NDR Delivered (Closed)', chartType: 'bar', fill: STATUS_COLORS.DELIVERED},
        {dataKey: 'totalRTO', label: 'NDR RTO (Closed)', chartType: 'bar', fill: STATUS_COLORS.RTO},
        {dataKey: 'totalLost', label: 'NDR Lost (Closed)', chartType: 'bar', fill: STATUS_COLORS.LOST},
        {dataKey: 'totalOpen', label: 'NDR Open', chartType: 'bar', fill: STATUS_COLORS.INTRANSIT}
    ]
}
export default function NDROverview({ data }) {
    return (
        <Card elevation={1}>
            <CardHeader title="NDR OverView" />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={2}>
                        <InfoBox header="Total NDR" value={formatNumber(data?.totalNDRCount)} />
                    </Grid>
                    <Grid item xs={2}>
                        <InfoBox header="NDR Open" value={formatNumber(data?.openNDRCount) + ' (' + numberPrecision(data?.openNDRCount*100/data?.totalNDRCount, 1)+ '%)'} tc='red'/>
                    </Grid>
                    <Grid item xs={2}>
                        <InfoBox header="NDR Closed - Delivered" value={formatNumber(data?.closedNDRDeliveredCount) + ' (' + numberPrecision(data?.closedNDRDeliveredCount*100/data?.totalNDRCount, 1)+ '%)'} />
                    </Grid>
                    <Grid item xs={2}>
                        <InfoBox header="NDR Closed - RTO" value={formatNumber(data?.closedNDRRTOCount) + ' (' + numberPrecision(data?.closedNDRRTOCount*100/data?.totalNDRCount, 1)+ '%)'} />
                    </Grid>
                    <Grid item xs={2}>
                        <InfoBox header="NDR Lost" value={formatNumber(data?.closedNDRLostCount) + ' (' + numberPrecision(data?.closedNDRLostCount*100/data?.totalNDRCount, 1)+ '%)'} tc='red' />
                    </Grid>
                    <Grid item xs={2}>
                        <InfoBox header="NDR Closed %" value={numberPrecision((data?.closedNDRRTOCount + data?.closedNDRDeliveredCount)*100/data?.totalNDRCount)} />
                    </Grid>
                   
                    <Grid item xs={12} sx={{ mt: 2 }}>
                        <StackedBarChart data={data.lineChartData} chartOptions={chartOptions} />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}